import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useCreateLiveCleanroom = (crId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    async (payload) => {
      const { data } = await axiosInstance.post(liveCleanroom(orgId).create(crId), payload);
      return data;
    },
    {
      onSuccess: () => {
        dispatch(showAlert({ message: 'Live cleanroom created successfully', type: 'success' }));
      },
      onError: (error) => {
        const errorMessage = error.response?.data?.message;
        if (errorMessage === 'No datasets configured for Live Clean Room') return;
        dispatch(showAlert({
          message: errorMessage ?? 'Error creating live cleanroom',
          type: 'error',
        }));
      },
    },
  );
};

